import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { IProductoClasificacion, WsProducto, IWsProducto } from '../classes/ws-producto';

@Injectable()
export class WsProductoService {
  endpoint = `/api/productos`;

  constructor(private http: HttpClient) { }

  getAll(filters: any): Observable<any> {
    let params = new HttpParams();
    Object.keys(filters).forEach(key => {
      if (filters[key]) {
        params = params.set(key, filters[key]);
      }
    });

    return this.http.get(`${this.endpoint}`, { headers: { context: '.products-grid' }, params })
      .pipe(map((res: any) => {
        return {
          ...res,
          datos: res.datos.map((value: IWsProducto) => new WsProducto(value))
        }
      }));
  }

  get(id: number, ctx?: any): Observable<WsProducto> {
    return this.http.get<IWsProducto>(`${this.endpoint}/${id}`, { headers: { context: ctx || 'body' } })
      .pipe(
        map(res => new WsProducto(res))
      );
  }

  insert(item): Observable<number> {
    const ws = { ...item };
    if (ws.Especificaciones && typeof ws.Especificaciones === 'object') {
      ws.Especificaciones = JSON.stringify(ws.Especificaciones);
    }

    return this.http.post<number>(`${this.endpoint}`, ws, { headers: { context: 'body' } });
  }

  delete(id): Observable<boolean> {
    return this.http.delete<boolean>(`${this.endpoint}/${id}`, { headers: { context: 'body' } });
  }

  getCategorias(): Observable<any> {
    // const headers = new HttpHeaders({ context: '.clsCategorias' });
    // return this.http.get(`${this.endpoint}/categorias`, { headers });

    return of([
      { Categoria: 'IMPRESORAS DE ESCRITORIO' },
      { Categoria: 'IMPRESORAS SEMI INDUSTRIALES' },
      { Categoria: 'IMPRESORAS TÉRMICAS TICKETERAS' },
      { Categoria: 'IMPRESORAS PORTÁTILES' },
      { Categoria: 'LECTORES Y ESCÁNERES' },
      { Categoria: 'IMPRESORAS DE TARJETAS DE PVC' },
      { Categoria: 'ACCESORIOS' },
      { Categoria: 'PESAJE' },
      { Categoria: 'SOFTWARE' },
      { Categoria: 'CODIFICACIÓN' },
      { Categoria: 'INSPECCIÓN' },
      { Categoria: 'FORMULARIOS ÓPTICOS' },
      { Categoria: 'TERMINALES PORTÁTILES' },
      { Categoria: 'CONECTIVIDAD' },
      { Categoria: 'EQUIPOS PUNTO DE VENTA' },
      { Categoria: 'EQUIPOS RFID' },
      { Categoria: 'SEGURIDAD Y ACCESO' },
      { Categoria: 'INSUMOS' },
    ]);
  }

  /* getLineas(): Observable<IProductoClasificacion[]> {
    // return this.http.get<IProductoClasificacion[]>(`${this.endpoint}/clasificacion/lineas`);

    return new Observable<IProductoClasificacion[]>(observer => {
      const result: [] = [
        { Id: '30', Detalle: 'ETIQUETAS' },
        { Id: '31', Detalle: 'CINTAS DE IMPRESIÓN' }
      ] as unknown as [];
      observer.next(result);
    });
  }

  getGrupos(IdLinea: string): Observable<IProductoClasificacion[]> {
    const headers = new HttpHeaders({ context: '.clsGrupos' });
    return this.http.get<IProductoClasificacion[]>(`${this.endpoint}/clasificacion/grupos/${IdLinea}`, { headers });
  }

  getTipos(IdLinea: string, IdGrupo: string): Observable<IProductoClasificacion[]> {
    const headers = new HttpHeaders({ context: '.clsTipos' });
    return this.http.get<IProductoClasificacion[]>(`${this.endpoint}/clasificacion/tipos/${IdLinea}/${IdGrupo}`, { headers });
  }

  getFamilias(IdLinea: string, IdGrupo: string, IdTipo: string): Observable<IProductoClasificacion[]> {
    const headers = new HttpHeaders({ context: '.clsFamilias' });
    return this.http.get<IProductoClasificacion[]>(`${this.endpoint}/clasificacion/familias/${IdLinea}/${IdGrupo}/${IdTipo}`, { headers });
  } */

}
